export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["AND_OPERATOR"] = "AND";
    LogicalOperator["OR_OPERATOR"] = "OR";
    LogicalOperator["LOGICAL_OPERATOR_UNSPECIFIED"] = "UNSPECIFIED";
})(LogicalOperator || (LogicalOperator = {}));
